import React from 'react';
import propTypes from 'prop-types';
import { FFM_CERTIFICATION_BLOCK_MESSAGE } from 'helpers/appointments/ffmCertification';
import { MISSING_OB_FORM_MESSAGE } from 'constants/enum';

export function AppointmentMessages({
  isInitialOnboardingFormIncomplete = false,
  isFfmCertificationBlocked,
  areApptsDisabled = false,
  hasOpenTransferRequests = false,
  statesAvailableButNoLicenses,
  isBlockedByBcbsCrossRequest,
  bcbsCrossRequestBlockMessage,
  isCarrierDisabledDueToBlackout,
  carrierDisabledDueToBlackoutMessage
}) {
  let primaryMessage = null;

  if (isInitialOnboardingFormIncomplete) {
    primaryMessage = (
      <p className='text-left leading-tight text-red-600 whitespace-pre-line'>
        {MISSING_OB_FORM_MESSAGE}
      </p>
    );
  } else if (isFfmCertificationBlocked) {
    primaryMessage = (
      <p className='text-left leading-tight text-red-600'>
        {FFM_CERTIFICATION_BLOCK_MESSAGE}
      </p>
    );
  } else if (areApptsDisabled) {
    primaryMessage = (
      <p className='text-left leading-tight text-red-600'>
        This carrier is not available for appointment requests at the moment.
      </p>
    );
  } else if (hasOpenTransferRequests) {
    primaryMessage = (
      <p className='text-left leading-tight text-red-600'>
        You currently have an open transfer request for this carrier. Once your
        transfer has been approved, you can add states to your appointment.
      </p>
    );
  } else if (statesAvailableButNoLicenses) {
    primaryMessage = (
      <p className='text-left leading-tight text-red-600'>
        No additional states available. You&apos;ve already submitted requests
        for all states you&apos;re eligible for, or you&apos;re not licensed in
        the remaining states.
      </p>
    );
  } else if (isBlockedByBcbsCrossRequest && bcbsCrossRequestBlockMessage) {
    primaryMessage = (
      <p className='text-left leading-tight text-red-600'>
        {bcbsCrossRequestBlockMessage}
      </p>
    );
  }

  return (
    <>
      {primaryMessage}

      {!isFfmCertificationBlocked && isCarrierDisabledDueToBlackout && (
        <p className='text-left leading-tight text-red-600'>
          {carrierDisabledDueToBlackoutMessage}
        </p>
      )}
    </>
  );
}

AppointmentMessages.propTypes = {
  isInitialOnboardingFormIncomplete: propTypes.bool,
  isFfmCertificationBlocked: propTypes.bool,
  areApptsDisabled: propTypes.bool,
  hasOpenTransferRequests: propTypes.bool,
  statesAvailableButNoLicenses: propTypes.bool,
  isBlockedByBcbsCrossRequest: propTypes.bool,
  bcbsCrossRequestBlockMessage: propTypes.string,
  isCarrierDisabledDueToBlackout: propTypes.bool,
  carrierDisabledDueToBlackoutMessage: propTypes.string
};
